export default __webpack_public_path__ + "static/gsk-e3ffe561824b44a48690dd46bd99ac69.png";